import React from "react";

import * as S from "./styled";

export const DOMINO_HELP_MAIL_ADDRESS = "help@dominoapp.net";

const LandingFooter = () => {
  return (
    <S.FooterSection>
      <div className="footer__information">
        <div data-company-address="">
          <h5>패스트포워드 주식회사</h5>
          <ul>
            <li>서울시 강남구 봉은사로 18길 60</li>
            <li>
              <a
                href={`mailto:${DOMINO_HELP_MAIL_ADDRESS}`}
                target="_top"
                rel="noopener noreferrer"
              >
                {DOMINO_HELP_MAIL_ADDRESS}
              </a>
            </li>
          </ul>
        </div>
        <ul data-company-learn-more="">
          <li className="info-tos">
            <a href="https://dominoapp.net/tos" rel="noopener noreferrer">
              이용약관
            </a>
          </li>

          <li className="info-privacy">
            <a href="https://dominoapp.net/privacy" rel="noopener noreferrer">
              개인정보 처리방침
            </a>
          </li>
        </ul>
        <p data-company-legalese="">
          도미노가 제공하는 금융정보는 단순히 정보의 제공을 목적으로 하고
          있으며, 제공되는 정보는 오류 및 지연이 발생할 수 있습니다. 도미노는
          이용자의 투자결과에 따른 법적인 책임을 지지 않습니다. 게시된 정보는
          무단으로 배포할 수 없습니다.
        </p>
      </div>
      <span data-footer-copyright="">
        © 2022 fastforward Inc. All rights reserved.
      </span>
    </S.FooterSection>
  );
};

export default LandingFooter;
